/** @jsxImportSource @emotion/react */

import { FC, ReactNode } from "react";
import Typography from "../../Typography";
import { ColorNames } from "../../../theme";
import CardContainer from "./CardContainer";
import { css } from "@emotion/react";

const styles = {
  row: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  bottom: {
    alignItems: "end",
  },
};

export interface CardProps {
  detailTop?: ReactNode;
  detailBottom?: ReactNode;
  cardData: {
    line1?: string;
    line2?: string;
    line3?: string;
    line4?: string;
    responsibleIcon?: any;
  };
  color: ColorNames;
  active: boolean;
  onClick?: () => void;
}

export type CardFC<T> = FC<{
  data: T;
  active: boolean;
  onClick?: () => void;
}>;

const Card: FC<CardProps> = ({
  detailBottom,
  detailTop,
  active,
  cardData,
  color,
  onClick,
}) => {
  return (
    <CardContainer onClick={onClick} borderColor={color} active={active}>
      <div css={styles.row}>
        <Typography
          variant="textLarge"
          align="left"
          uppercase
          component="div"
          weight="bold"
        >
          {cardData.line1 || ""}
        </Typography>
        {detailTop}
      </div>
      <br />
      <div css={css(styles.row, styles.bottom)}>
        <div>
          <Typography variant="textLarge" align="left" component="div">
            {cardData.line2 || "-"}
          </Typography>
          <Typography variant="textLarge" align="left" component="div">
            {cardData.line3 || "-"}
          </Typography>
          <Typography variant="textLarge" align="left" component="div">
            {cardData.line4 || "-"}
          </Typography>
        </div>
        <div>{detailBottom}</div>
      </div>
    </CardContainer>
  );
};

export default Card;
